<template>
  <div class="ma-5 ml-4 site_content">
    <!-- {{ this.$route.params }} -->

    <div class="temporary_content">
      <button type="submit" class="tempo_btn" @click="temporarySave()">
        <v-icon color="white" class="mr-1">mdi-content-save</v-icon>임시저장
      </button>
    </div>
    <div class="measure_container">
      <div class="flex title_section">
        <div class="line mr-2"></div>
        <div>계량화기술</div>
      </div>

      <div class="measure_content flex">
        <div class="calc_section">
          <v-dialog
            v-model="calc_dialog"
            width="850"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="flex vertical-center">
                <button type="submit" class="calc_btn"
                  v-bind="attrs"
                  v-on="on"
                  @click="calc_dialog = true">
                  온실가스 배출량 확인하기
                </button>
              </div>
            </template>

            <v-card class="cal_content">
              <div class="flex s-bt">
                <h4>농장단위 온실가스 배출량 산정 (돼지)</h4>
                <div style="cursor: pointer;" @click="calc_dialog=false">
                  <v-icon>mdi-close</v-icon>
                </div>
              </div>

              <div class="mt-3 esg_content">
                <div>・ 장내발효 (정밀사양)</div>
                <div class="flex ma-1 mt-4">
                  <v-text-field dense outlined 
                    class="textfield"
                    id="allkg" 
                    ref="allkg"
                    label="(비육돈)전체 도체중" 
                    v-model.number="calData.allkg" 
                    @change="calESG"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="allship" 
                    ref="allship"
                    label="(비육돈)연간 출하두수" 
                    v-model.number="calData.allship" 
                    @change="calESG"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="allgrow" 
                    ref="allgrow"
                    label="(모돈)연간 사육두수" 
                    v-model.number="calData.allgrow" 
                    @change="calESG"
                  />
                  <div class="fermentation_info">
                    <div class="info_label">(비육돈)평균 도체중</div>
                    <div>
                      {{ this.calData.avg_kg }}
                    </div>
                  </div>

                  <div class="fermentation_info">
                    <div class="info_label">MSY</div>
                    <div>
                      {{ this.calData.msy }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex mt-3">
                <div class="esg_content">
                  <div>・ 장내발효(질소저감 사료 급이)</div>

                  <div class="flex ma-1 mt-4">
                    <v-text-field dense outlined 
                      class="textfield"
                      id="totalgrow" 
                      ref="totalgrow"
                      label="사육두수" 
                      v-model="calData.totalgrow" 
                    />
                    <v-text-field dense outlined 
                      class="textfield"
                      id="feedgrow" 
                      ref="feedgrow"
                      label="급이두수" 
                      v-model="calData.feedgrow" 
                    />
                </div>
              </div>
              <div class="esg_content info_ch4 ml-3">
                <div class="info_title">장내발효 <span>CH₄</span></div>

                <div class="cal_info">
                  <div class="info_label">기준 배출량</div>
                  <div>
                    17.1
                  </div>
                </div>

                <div class="cal_info">
                  <div class="info_label">감축량</div>
                  <div>
                    감축량 숫자
                  </div>
                </div>

                <div class="cal_info">
                  <div class="info_label">최종배출량</div>
                  <div>
                    최종 숫자
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-3 esg_content">
              <div>・ 분뇨처리 (분뇨처리방법 비율)</div>
              <div class="flex ma-1 mt-4">
                <v-text-field dense outlined 
                  class="textfield_large"
                  id="self_manure" 
                  ref="self_manure"
                  label="자가처리" 
                  suffix ="%"
                  v-model.number="calData.self_manure"
                  @change="manureCount" 
                />
                <v-text-field dense outlined 
                  class="textfield_large"
                  id="consign_manure" 
                  ref="consign_manure"
                  label="자가처리" 
                  suffix ="%"
                  v-model.number="calData.consign_manure" 
                  @change="manureCount" 
                />
                <div class="fermentation_info_large">
                  <div class="info_label">총 계(100%)</div>
                  <div >
                    {{ this.calData.total_percent }}
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <div>・ 분뇨처리 (자가처리방식)</div>
                <div class="flex ma-1 mt-4">
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_accu" 
                    ref="self_accu"
                    label="(퇴비화)퇴비사 축적" 
                    suffix ="%"
                    v-model.number="calData.self_accu" 
                    @change="selfManure"
                  />

                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_air" 
                    ref="self_air"
                    label="(퇴비화)강제공기공급"
                    suffix ="%" 
                    v-model.number="calData.self_forceair" 
                    @change="selfManure"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_machine" 
                    ref="self_machine"
                    label="(퇴비화)기계교반" 
                    suffix ="%"
                    v-model.number="calData.self_machine" 
                    @change="selfManure"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_liquid" 
                    ref="self_liquid"
                    label="액비・정화처리" 
                    suffix ="%"
                    v-model.number="calData.self_liquid" 
                    @change="selfManure"
                  />
                  <div class="fermentation_info">
                    <div class="info_label">총 계 (100%)</div>
                    <div style="font-size:13px; margin-top:3px;">
                      {{ this.calData.self_percent }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-3">
                <div>・ 분뇨처리 (위탁처리)</div>
                <div class="flex ma-1 mt-4">
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_accu" 
                    ref="self_accu"
                    label="(퇴비화)퇴비사 축적" 
                    suffix ="%"
                    v-model.number="calData.consign_accu" 
                    @change="consignManure"
                  />

                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_air" 
                    ref="self_air"
                    label="(퇴비화)강제공기공급"
                    suffix ="%" 
                    v-model.number="calData.consign_forceair" 
                    @change="consignManure"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_machine" 
                    ref="self_machine"
                    label="(퇴비화)기계교반" 
                    suffix ="%"
                    v-model.number="calData.consign_machine" 
                    @change="consignManure"
                  />
                  <v-text-field dense outlined 
                    class="textfield"
                    id="self_liquid" 
                    ref="self_liquid"
                    label="액비・정화처리" 
                    suffix ="%"
                    v-model.number="calData.consign_liquid" 
                    @change="consignManure"
                  />
                  <div class="fermentation_info">
                    <div class="info_label">총 계 (100%)</div>
                    <div style="font-size:13px; margin-top:3px;">
                      {{ this.calData.consign_percent }}
                    </div>
                  </div>
                </div>
              </div>
              <div style="color:gray; font-size:11px; margin-left:10px; margin-top:10px;"> * 분뇨처리 방법 비율 중 자가처리 또는 위탁처리 비율이 0%인 경우를 제외하고 각 비율총계는 반드시 100%가 되어야 함</div>
            </div>

            <div class="esg_content info_ch4 mt-3">
              <div class="info_title">분뇨처리 <span>CH₄ + N₂O</span></div>

              <div class="cal_info">
                <div class="info_label">기준 배출량</div>
                <div>
                  190.0
                </div>
              </div>

              <div class="cal_info">
                <div class="info_label">감축량</div>
                <div>
                  감축량 숫자
                </div>
              </div>

              <div class="cal_info">
                <div class="info_label">최종배출량</div>
                <div>
                  최종 숫자
                </div>
              </div>
            </div>

            <div class="mt-3 esg_content">
              <div>・ 전력에너지</div>

              <div class="flex mt-2 vertical-center">
                <div>
                  <div class="flex energy_content">
                    <div class="energy_title">설비 전</div>
                    <v-text-field dense outlined 
                      class="textfield"
                      id="before_energy_grow" 
                      ref="before_energy_grow"
                      label="월 평균 사육두수" 
                      suffix ="두"
                      v-model.number="calData.before_energy_grow" 
                      @change="energyCount"
                    />

                    <v-text-field dense outlined 
                      class="textfield"
                      id="before_energy_elec" 
                      ref="before_energy_elec"
                      label="전력사용량" 
                      v-model.number="calData.before_energy_elec" 
                      @change="energyCount"
                    />

                    <div class="cal_info">
                      <div class="info_label">전력사용량 (두)</div>
                      <div>
                        {{ calData.before_energy_pigelec }}
                      </div>
                    </div>
                  </div>

                  <div class="flex energy_conten mt-5">
                    <div class="energy_title">설비 후</div>
                    <v-text-field dense outlined 
                      class="textfield"
                      id="after_energy_grow" 
                      ref="after_energy_grow"
                      label="월 평균 사육두수" 
                      suffix ="두"
                      v-model.number="calData.after_energy_grow" 
                      @change="AfterEnergyCount"
                    />

                    <v-text-field dense outlined 
                      class="textfield"
                      id="after_energy_elec" 
                      ref="after_energy_elec"
                      label="전력사용량" 
                      v-model.number="calData.after_energy_elec" 
                      @change="AfterEnergyCount"
                    />

                    <div class="cal_info">
                      <div class="info_label">전력사용량 (두)</div>
                      <div>
                        {{ calData.after_energy_pigelec }}
                      </div>
                    </div>
                  </div>
                </div>
               
                <div class="energyp_info ml-10">
                  <div class="info_label">감축비율</div>
                  <div class="mt-5">
                    {{ calData.ratio_energy_pigelec }} %
                  </div>
                </div>
              </div>

              <div style="color:gray; font-size:11px; margin-left:10px; margin-top:10px;">
                * 감축기술이 적용되지 않은 경우 데이터를 입력하지 않으며, 전력사용량 데이터 산정은 설비 전, 후 기간과 단위가 동일해야 함
              </div>
             
            </div>

            <div class="mt-3 esg_content">
              <div>・ 유류에너지</div>

              <div class="flex mt-2 vertical-center">
                <div>
                  <div class="flex energy_content">
                    <div class="energy_title">설비 전</div>
                    <v-text-field dense outlined 
                      class="textfield"
                      id="before_energy_grow" 
                      ref="before_energy_grow"
                      label="월 평균 사육두수" 
                      suffix ="두"
                      v-model.number="calData.before_energy_grow" 
                      @change="fuelCount"
                    />

                    <v-text-field dense outlined 
                      class="textfield"
                      id="before_energy_fuel" 
                      ref="before_energy_fuel"
                      label="유류사용량" 
                      v-model.number="calData.before_energy_fuel" 
                      @change="fuelCount"
                    />

                    <div class="cal_info">
                      <div class="info_label">유류사용량 (두)</div>
                      <div>
                        {{ calData.before_energy_pigfuel }}
                      </div>
                    </div>
                  </div>

                  <div class="flex energy_conten mt-5">
                    <div class="energy_title">설비 후</div>
                    <v-text-field dense outlined 
                      class="textfield"
                      id="after_energy_grow" 
                      ref="after_energy_grow"
                      label="월 평균 사육두수" 
                      suffix ="두"
                      v-model.number="calData.after_energy_grow" 
                      @change="AfterfuelCount"
                    />

                    <v-text-field dense outlined 
                      class="textfield"
                      id="after_energy_fuel" 
                      ref="after_energy_fuel"
                      label="유류사용량" 
                      v-model.number="calData.after_energy_fuel" 
                      @change="AfterfuelCount"
                    />

                    <div class="cal_info">
                      <div class="info_label">유류사용량 (두)</div>
                      <div>
                        {{ calData.after_energy_pigfuel }}
                      </div>
                    </div>
                  </div>
                </div>
               
                <div class="energyp_info ml-10">
                  <div class="info_label">감축비율</div>
                  <div class="mt-5">
                    {{ calData.ratio_energy_pigfuel }} %
                  </div>
                </div>
              </div>

              <div style="color:gray; font-size:11px; margin-left:10px; margin-top:10px;">
                * 감축기술이 적용되지 않은 경우 데이터를 입력하지 않으며, 유류사용량 데이터 산정은 설비 전, 후 기간과 단위가 동일해야 함
              </div>
            </div>

            <div class="esg_content info_ch4 info_eng mt-3">
              <div class="info_title">
                에너지 
              </div>

              <div>
                <div class="flex vertical-center">
                  <div>전력</div>
                  <div class="cal_info">
                    <div class="info_label">기준 배출량</div>
                    <div>
                      190.0
                    </div>
                  </div>

                  <div class="cal_info">
                    <div class="info_label">감축량</div>
                    <div>
                      감축량 숫자
                    </div>
                  </div>

                  <div class="cal_info">
                    <div class="info_label">최종배출량</div>
                    <div>
                      최종 숫자
                    </div>
                  </div>
                </div>

                <div class="flex vertical-center">
                  <div>유류</div>
                  <div class="cal_info">
                    <div class="info_label">기준 배출량</div>
                    <div>
                      190.0
                    </div>
                  </div>

                  <div class="cal_info">
                    <div class="info_label">감축량</div>
                    <div>
                      감축량 숫자
                    </div>
                  </div>

                  <div class="cal_info">
                    <div class="info_label">최종배출량</div>
                    <div>
                      최종 숫자
                    </div>
                  </div>
                </div>
              </div>
              
              
            </div>

          </v-card>
        </v-dialog>

          <div class="info_section">
            <div v-if="cal_result">

            </div>
            <div v-else class="else_result">
              배출량 확인하기를 눌러 예상 감축률을 확인해주세요.
            </div>
          </div>
        </div>

        <div class="chart_section">
          <Bar 
          :chart-data="chartData"  
          :style="chartSize" 
          :chart-options="barChartOptions" ></Bar>
        </div>
      </div>
      
      <div class="flex vertical-center">
        <div class="score_section">
          <div class="score_title">계량화 평가</div>
          <div> {{ Measure_score }} </div> <!--실점수-->
          <div class="ml-1"> / 70점</div>
        </div>
      </div>
    </div>

    <div class="Nonmeasure_container">
      <div class="flex title_section">
        <div class="line mr-2"></div>
        <div>비계량화기술</div>
      </div>

      <div class="Nonmeasure_content flex">
        <div class="manage_content">
          <h4>사양관리</h4>
          <div class="feed_section">
            <div class="flex">
              <div class="title_score">사료효율 개선</div>
              <div class="sub_score"> 
                <span class="mr-1">{{ feed_score }}</span>
                <span class="ml-1">/ 4</span>
              </div>
            </div>

            <div class="flex s-bt" style="margin-top:-10px;">
              <v-checkbox
                v-for="(item, i) in feed"
                :key="i"
                class="checkbox"
                v-model="item.checked"
                :label="item.label"
                color="#005B96"
                @change="scoreTotal"
              ></v-checkbox>
            </div>
          </div>
          <div class="machine_section">
            <div class="grow_section">
            <div class="flex">
              <div class="title_score">생산성 향상 장비 도입</div>
                <div class="sub_score"> 
                  <span class="mr-1">{{ machine_score }}</span>
                  <span class="ml-1">/ 2</span>
                </div>
              </div>

              <div class="flex s-bt" style="margin-top:-10px;">
                <v-checkbox
                  v-for="(item, i) in machine"
                  class="checkbox"
                  :key="i"
                  v-model="item.checked"
                  :label="item.label"
                  color="#005B96"
                  @change="scoreTotal"
                >
                </v-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="manure_content ml-3">
          <div class="flex">
            <h4>가축분뇨처리</h4>
            <div class="sub_score"> 
              <span class="mr-1">{{ manure_score }}</span>
              <span class="ml-1">/ 14</span>
            </div>
          </div>
          
          <div class="manure_section">
            <v-checkbox
              v-for="(item, i) in manure"
              class="checkbox"
              :key="i"
              v-model="item.checked"
              :label="item.label"
              color="#005B96"
              @change="scoreTotal"
            >
            <template v-slot:label>
                <div style="display: flex; flex-direction: column;">
                  <div>{{ item.label }}</div>
                  <span style="font-size: 12px; color: gray; margin-top:-5px;">{{ item.memo }}</span>
                </div>
              </template>
            </v-checkbox>
          </div>
        </div>
      </div>
      
      <div class="flex vertical-center">
        <div class="score_section">
          <div class="score_title">비계량화 평가</div>
          <div> {{ nonMeasure_score }} </div> <!--실점수-->
          <div class="ml-1"> / 20점</div>
        </div>
      </div>
    </div>

    <div class="etcFarm_container">
      <div class="flex title_section">
        <div class="line mr-2"></div>
        <div>기타 농장 관리</div>
      </div>

      <div class="etcFarm_content">
        <v-checkbox
          v-for="(item, i) in farms"
          :key="i"
          v-model="item.checked"
          color="#005B96"
          @change="scoreTotal"
          class="checkbox-group"
        >
          <template v-slot:label>
            <div class="checkbox-label">
              <div class="checkbox-chip">{{ item.chip }}</div>
              <div>
                <div class="checkbox-title">{{ item.label }}</div>
                <div class="checkbox-description">{{ item.memo }}</div>
              </div>
            </div>
          </template>
        </v-checkbox>
      </div>

      <div>
        <div class="flex vertical-center">
          <div class="score_section">
            <div class="score_title">농장관리</div>
            <div> {{ farm_score }} </div> <!--실점수-->
            <div class="ml-1"> / 10점</div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex vertical-center">
      <div class="result_farm">
        <span style="font-weight:550">{{ $route.params.farm.name }}</span> 은(는) 축산물 품질 평가원에서 진행하는 <br/>
        '2025 저탄소 축산물 인증 시범 사업' 모집대상 농가로 지원이
        <span v-if="total_score >= 75" class="blue-text"> 가능 합니다.</span>
        <span v-else style="font-weight:600;" class="red-text"> 불가능 합니다.</span>
      </div>
    </div>

    <div class="flex vertical-center mt-5" style="flex-direction: column;">
      계량화 {{ Measure_score }} | 비계량화 {{ nonMeasure_score }} | 농장관리 {{ farm_score }}  <br/>
      
      <div class="flex vertical-center">
        <div class="total_score ml-15">
          <div class="total_title">합계 점수</div>
          <div> {{ total_score }}</div>
          <div> /100점</div>
        </div>

        <button class="reset_btn" type="submit" @click="resetData()">
          <v-icon color="white" size="20">mdi-refresh
            mdi-rotate-90 
          </v-icon>
        </button>
      </div>
     


    </div>

  </div>
</template>

<script>
import Apis from '@/api/apis';

import { Bar }  from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
import { barChartOptions} from "@/components/chart/option.js";  // 옵션 불러오기

export default ({
  name:"Lowcarbon",

  components: { Bar },

  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
    
    if(!this.$route.params.farm){
      this.$router.go(-1);
    }

    this.calculEsg();
  },
  mounted() {
    this.loadTempData();
  },
  data(){
    return{
      barChartOptions:barChartOptions,

      calc_dialog:false,
      cal_result:false,

      calData:{
        allkg : 0,
        allship : 0,
        allgrow : 0,

        avg_kg:0,
        msy:0,

        totalgrow:0,
        feedgrow:0,

        self_manure:0,
        consign_manure:0,

        total_percent:'',

        self_accu:0,
        self_forceair:0,
        self_machine:0,
        self_liquid:0,

        self_percent:'',

        consign_accu:0,
        consign_forceair:0,
        consign_machine:0,
        consign_liquid:0,

        consign_percent:'',

        before_energy_grow:0,
        before_energy_elec:0,

        before_energy_pigelec:0,

        after_energy_grow:0,
        after_energy_elec:0,
        after_energy_pigelec:0,

        ratio_energy_pigelec:0,

        before_energy_fuel:0,
        after_energy_fuel:0,

        before_energy_pigfuel:0,
        after_energy_pigfuel:0,

        ratio_energy_pigfuel:0,

        
      },

      feed_score:0,
      machine_score:0,
      manure_score:0,
      nonMeasure_score:0,

      Measure_score:0,
      easure_score:0,
      farm_score:0,
      total_score:0,

      feed: [
        { label: "유용미생물", checked: false, score: 1 },
        { label: "유기산제", checked: false, score: 1 },
        { label: "비타민", checked: false, score: 1 },
        { label: "미네랄", checked: false, score: 1 },
      ],
      machine: [
        { label: "모돈 급이기", checked: false, score: 0.5 },
        { label: "사료 급이기", checked: false, score: 0.5 },
        { label: "환기, 환경 제어기", checked: false, score: 0.5 },
        { label: "음수투약기", checked: false, score: 0.5 },
      ],
      manure: [
        { label: "피트 내 슬러리 관리", memo : '월 1회 이상 처리 및 침전물 모두 제거', checked: false, score: 4 },
        { label: "바이오차 생산", memo : '비농업계 이용', checked: false, score: 2 },
        { label: "바이오 에너지화 시설(고체연료)", checked: false, score: 2 },
        { label: "바이오 에너지화 시설(바이오가스)", checked: false, score: 2 },
        { label: "액비순환 시스템 활용", checked: false, score: 4 },
      ],
      farms:[
        { chip:"사육밀도", label: "피트 내 슬러리 관리", memo : '월 1회 이상 처리 및 침전물 모두 제거', checked: false, score: 3 },
        { chip:"악취방지", label: "분뇨의 바이오 에너지화", memo : '바이오 커튼, 바잉 필터 등 설비활용', checked: false, score: 3 },
        { chip:"나무식재", label: "산림 탄소 흡수원 보전", memo : '한돈협회 캠페인 참여, 축사 내외 나무 식재', checked: false, score: 2 },
        { chip:"유통망확보", label: "액비 순환 시스템 활용", memo : '계약에 의한 고정 판로 확보', checked: false, score: 2 },
      ],

      chartData: {
        labels: [],
        datasets: []
      },

      chartSize: {
        // position: 'relative';
        height: '200px',
      },

    }
  },
  methods:{
    scoreTotal(){
      this.feed_score = this.feed
      .filter(item => item.checked)
      .reduce((sum, item) => sum + item.score, 0);

      this.machine_score = this.machine
      .filter(item => item.checked)
      .reduce((sum, item) => sum + item.score, 0);

      this.manure_score = this.manure
      .filter(item => item.checked)
      .reduce((sum, item) => sum + item.score, 0);

      this.nonMeasure_score = this.feed_score + this.machine_score + this.manure_score ;

      this.farm_score = this.farms
      .filter(item => item.checked)
      .reduce((sum, item) => sum + item.score, 0);

      this.total_score = this.nonMeasure_score + this.farm_score + this.Measure_score
    },
    calESG(){
      this.calData.avg_kg = this.calData.allkg / this.calData.allship
      this.calData.msy = this.calData.allship / this.calData.allgrow
    },
    manureCount(){
      if((this.calData.self_manure + this.calData.consign_manure) == 100 ){
        this.calData.total_percent = '100%'
      } else{
        this.calData.total_percent = '총계는 100%가 되어야 합니다.'
      }
    },
    selfManure(){
      if( (this.calData.self_accu + this.calData.self_forceair + this.calData.self_machine + this.calData.self_liquid) == 100 ) {
        this.calData.self_percent = '100%'
      } else{
        this.calData.self_percent = '100%가 되어야합니다.'
      }
    },
    consignManure(){
      if( (this.calData.consign_accu + this.calData.consign_forceair + this.calData.consign_machine + this.calData.consign_liquid) == 100 ) {
        this.calData.consign_percent = '100%'
      } else{
        this.calData.consign_percent = '100%가 되어야합니다.'
      }
    },
    energyCount(){
      this.calData.before_energy_pigelec =  this.calData.before_energy_elec / this.calData.before_energy_grow;
      this.ratioEnergy();
    },
    AfterEnergyCount(){
      this.calData.after_energy_pigelec =  this.calData.after_energy_elec / this.calData.after_energy_grow;
      this.ratioEnergy();
    },
    ratioEnergy(){
      this.calData.ratio_energy_pigelec = (this.calData.before_energy_pigelec - this.calData.after_energy_pigelec) / this.calData.before_energy_pigelec * 100;
    },
    fuelCount(){
      this.calData.before_energy_pigfuel =  this.calData.before_energy_fuel / this.calData.before_energy_grow;
      this.ratioFuel();
    },
    AfterfuelCount(){
      this.calData.after_energy_pigfuel =  this.calData.after_energy_fuel / this.calData.after_energy_grow;
      this.ratioFuel();
    },
    ratioFuel(){
      this.calData.ratio_energy_pigfuel = (this.calData.before_energy_pigfuel - this.calData.after_energy_pigfuel) / this.calData.before_energy_pigfuel * 100;
    },
    resetData(){
      this.feed_score = 0;
      this.machine_score = 0;
      this.manure_score = 0;
      this.nonMeasure_score = 0;
      
      this.Measure_score = 0;
      this.easure_score = 0;
      this.farm_score = 0;
      this.total_score = 0;

      [this.feed, this.machine, this.manure, this.farms].forEach(group => {
        group.forEach(item => {
          item.checked = false;
        });
      });
    },
    calculEsg(){
      this.chartData = this.drawChart();
    },
    drawChart(){
      return{
        labels: [1],
        datasets: [
          {
            label: '내 농장', 
            barPercentage: 0.3,
            data: [],
            backgroundColor: 'rgba(244, 209, 96, 0.6)', 
            
          },
          {
            label: '목표 배출량', 
            barPercentage: 0.3,
            data: [2.21],
            backgroundColor: 'rgba(90, 114, 160, 0.6)', 
          }
        ]
      }
    },
    temporarySave(){
      const EsgData = {
        feed : this.feed,
        machine : this.machine,
        manure : this.manure,
        farms : this.farms
      };

      localStorage.setItem("tempCheckData", JSON.stringify(EsgData))
      alert("임시저장이 완료 되었습니다.");
    },
    loadTempData() {
      const savedData = localStorage.getItem("tempCheckData");
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        this.feed = parsedData.feed || this.feed;
        this.machine = parsedData.machine || this.machine;
        this.manure = parsedData.manure || this.manure;
        this.farms = parsedData.farms || this.farms;
      }
    }
  }
})
</script>

<style scoped lang=scss>
@import '../../style/base.scss';
.measure_container, .Nonmeasure_container, .etcFarm_container{
  width:90%;
  margin:0 auto;
}
.measure_content, .Nonmeasure_content ,.etcFarm_content {
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  padding:20px;
  letter-spacing: -1px;
}
.measure_content{
  display: flex;
  align-items: center;
}
.Nonmeasure_content{
  padding:0;
}
.title_section{
  font-size:17px;
  font-weight:600;
  margin-bottom: 10px;
}
.calc_section{
  width:70%;
}
.chart_section{
  width:30%;
}
.manage_content{
  width:60%;
}
.manure_content{
  width:40%;
}
.manage_content, .manure_content{
  padding:20px;
  // margin-top:10px;
}
.manure_section ,.feed_section, .machine_section{
  padding:10px 20px 20px;
  border:1px solid #D8D8D8;
  margin-top:10px;
  border-radius: 20px;
}
.sub_score{
  background-color: $main-color;
  color:white;
  padding: 0 10px;
  font-size:12px;
  line-height: 25px;
  border-radius: 20px;
  width:60px;
  margin-left:10px;
  text-align: center;
}
.calc_btn{
  padding:15px 30px;
  color:white;
  border-radius: 20px;
  font-weight:650;
  background-color: $main-color!important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.cal_content{
  padding:30px;
}
.info_section{
  padding:30px;
  border:1px solid #D8D8D8;
  margin-top:10px;
  border-radius: 20px;
}
.else_result{
  text-align: center;
  font-size:20px;
  font-weight:650;
}
.chart_section{
  margin-left:10px;
}
.score_section{
  margin-top:15px;
  font-weight: 700;
  width:300px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding:10px;
  border-radius: 15px;
  letter-spacing: -0.43px;
  color: #005B96;
  font-size:20px;
  background-color:$menu-color;
}
.score_section .score_title{
  width:140px;
  font-size:17px !important;
  font-weight:550 !important;
}
.manure_section{
  padding:0px 10px 10px 20px !important;
  // padding-top:-20px !important;
  // margin-top:px !important;
}
.manure_section .checkbox{
  margin-top:10px;
}
::v-deep .checkbox{
  max-height:25px !important;
}
.etcFarm_content{
  display: flex;
  flex-wrap: wrap;
  gap: 10px; 
  // justify-content: center !important;
  justify-content: center !important;
}
.checkbox-group {
  width: calc(50% - 100px);
  // width:auto; 
  display: flex;
  align-items: center ;
  height:25px;
}
.checkbox-label{
  display: flex;
  align-items: center;
}
.checkbox-chip{
  padding:8px;
  width:100px;
  text-align: center;
  margin-right:20px;
  background-color: #E8E8E8;
  border-radius: 15px;
}
.checkbox-description{
  font-size:12px;
  color:gray;
}

.result_farm{
  margin-top:30px;
  background-color: $menu-color;
  padding:20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 29px;
  min-width:550px;
}
.total_score{
  min-width: 270px;
  background-color: #005B96;
  padding:15px;
  color:white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  display:flex;
  justify-content: center;
  align-items: center;
}
.total_score .total_title{
  width:120px !important;
}
.total_score div{
  font-weight:600;
  font-size:20px !important;
  // width:120px;
}
.reset_btn{
  background-color: $main-color;
  margin-left:5px;
  padding:10px;
  min-width:30px;
  min-height:30px;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.temporary_content{
  position: static !important;
}
.tempo_btn{
  position: fixed;
  top:10px;
  right: 250px;
  z-index: 2;

  background-color: $point-color;
  padding:15px;
  border-radius: 30px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color:white;
  letter-spacing: -1px;
  font-weight:600;
  height:50px;
  transition: all 0.2s ease;
}
.tempo_btn:hover{
  background-color: $main-color !important;
  color:white !important;
}
.textfield , .fermentation_info, .cal_info , .textfield_large , .fermentation_info_large{
  margin-right:5px;
  // box-shadow: 1px 1px 3p rgba(0, 0, 0, 0.25);
  height:45px;
  border:1px solid #d0d0d0;
  border-radius: 30px;
  max-width:140px;
  margin-right:10px !important;
}
::v-deep .textfield .v-text-field__slot , ::v-deep .textfield_large .v-text-field__slot {
  height: 43px !important;
}
::v-deep .textfield .v-label ,::v-deep .textfield_large .v-label{
  background-color: white;
}
::v-deep .textfield #allship , ::v-deep .textfield #allgrow , ::v-deep .textfield #allkg{
  text-align: center !important;
}
.fermentation_info, .cal_info ,.fermentation_info_large{
  text-align: center;
  min-width:140px;
  font-weight:600;
  background-color: #f4f4f4;
}
.cal_info{
  min-width:100px;
  background-color: #f2f2f2 !important;
}
.fermentation_info .info_label ,.cal_info .info_label ,.fermentation_info_large .info_label{
  font-size:12px;
  margin-top:-10px;
  margin-left:15px;
  text-align: left;
}
.esg_content{
  border: 1px solid #bababa;
  padding:10px;
  border-radius: 20px;
}
.info_title{
  font-weight: 550;
  margin-right:10px;
}
.info_title span{
  font-size:14px;
}
.info_ch4{
  display:flex;
  align-items: center;
  justify-content: center;
  border:none;
  background-color: $menu-color;
  // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.textfield_large ,.fermentation_info_large{
  max-width:30vw !important;

}
.fermentation_info_large{
  width:250px;
}
.fermentation_info_large div{
  font-size:15px;
  margin-top:2px;
}
.energy_content{
  align-items: center;
}
.energy_title{
  width:100px;
  text-align: center;
  font-weight: 550;
}
.energyp_info{
  // height:50px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  background-color: #f2f2f2;
  padding:30px;
  text-align: center;
  border-radius: 20px;
}
.energyp_info .info_label{
  margin-top:-37px;
  font-size:15px;
  font-weight:600;
}

</style>